import { LuFileSearch } from "react-icons/lu"
import { useEffect, useState } from "react"
import { toast } from "react-toastify"
import useDataBean from "../../../../../../../core/services/dataBean/useDataBean";
import { _AppointmentManualPdf, _single } from "../../../../../../../core/services/dataBean/EntityCatalog";
import useModal, { MODAL_XL } from "../../../../../../theme/Component/hooks/useModal";
import { FileService } from "../../../../../../../core/services/FileService";
import { YearSelector } from "../../../../../../../core/shared/inputs/YearSelector";
import { SelectMonths } from "../../../../../../contract/select/SelectMonths";
import { IconButton } from "../../../../../../../core/shared/buttons/IconButton";
import { Modal } from "../../../../../../theme/Component/Modal";
import { VisorAnyDocument } from "../../../../../../documents/VisorAnyDocument";


type FormProps = {
    Year: number;
    Month: number;
}

interface ManualDashedProps {
    IDAccount?: number;
}

export const AppointmentManualPdfDashed = ({ IDAccount }: ManualDashedProps) => {

    const { instance, lista, setLista, bean, setBean } = useDataBean(_AppointmentManualPdf)
    const [form, setForm] = useState<FormProps>({
        Month: _single.getCurrentMonth(),
        Year: _single.getCurrenYear(),
    })
    const modalDoc = useModal("Manual", MODAL_XL);

    useEffect(() => {
        if (typeof (form.Month) == "number" && form.Year) {
            getLista();
        }
    }, [form])

    const getFileType = (mediaName: string) => {
        let fileType = mediaName.split('.').pop()?.toLowerCase();
        return fileType;
    }

    const getLista = () => {
        instance.getAppointmentManualByIDEmployee(IDAccount ?? _single.getAccountID(), form.Year, form.Month).then(
            (resp) => {
                resp.List.forEach(manuales => {
                    const manual = manuales.DataBeanProperties;
                    if (manual.ManualPDF) {
                        const data = manual.ManualPDF.DataBeanProperties;
                        manual.URL = fileService.getUrlFile(data.MediaContext, data.Media);
                        manual.DocType = getFileType(data.Media);
                    }
                });
                setLista(resp.List)
            }
        ).catch(
            err => toast.error(err)
        )
    }

    const fileService = new FileService();

    useEffect(() => {
        if (bean.IDLn) {
            if (bean.ManualPDF) {
                modalDoc.open();
            } else {
                toast.error("No presenta documento")
            }
        }
    }, [bean])

    useEffect(() => {
        if (modalDoc.modal.view === false) {
            setBean({})
        }
    }, [modalDoc.modal.view])

    return (
        <div className="row">
            {/* <div className="col-12">
                <ContractEditor idAccount={single.getAccountID()} onChange={(e) => { setContrac(e) }} />
            </div> */}
            <div className="col-md-6">
                <YearSelector onChange={(e) => { setForm({ ...form, Year: e }) }} value={form.Year} tittle="Vigencia" />
            </div>
            <div className="col-md-6">
                <SelectMonths idSelector={form.Month} onChange={(e) => { setForm({ ...form, Month: e }) }} label="Mes" />
            </div>
            <div className="col-md-12 ">
                <ul>
                    {lista.map((oficinas: any) => {
                        const oficina = oficinas.DataBeanProperties;
                        return (
                            <li className="d-flex mb-4 pb-3 border-bottom" style={{ width: "90%" }}>
                                <div className="avatar flex-shrink-0 me-3">
                                    <div style={{ color: '#006699', fontSize: '60px' }}>
                                        <LuFileSearch />
                                    </div>
                                </div>
                                <div className="d-flex w-100 flex-wrap align-items-center justify-content-between gap-2">
                                    <div className="me-2">
                                        <small className="text-muted d-block mb-1">{oficina.AccountName} - {oficina.IDLn}</small>
                                        <h6 className="mb-0">{`${oficina.FunctionalIDName}`}</h6>
                                    </div>
                                    {oficina.ManualPDF &&
                                        <div className="d-flex align-items-center gap-1">
                                            <IconButton
                                                icon="ri-file-download-line"
                                                event={() => { setBean(oficina) }}
                                            />
                                        </div>
                                    }
                                </div>
                            </li>
                        )
                    })}
                </ul>
            </div>

            <div className="col-md-12">
                <Modal modal={modalDoc.modal} updateModal={modalDoc.setModal}>
                    <div className="row">
                        <div className="col-md-12">
                            <strong>Manual:</strong>
                            <div dangerouslySetInnerHTML={{ __html: bean.ManualPDF?.DataBeanProperties?.Media }}></div>
                        </div>
                        <div className="col-md-12">
                            <strong>Versión:</strong>
                            <div dangerouslySetInnerHTML={{ __html: bean.ManualPDF?.DataBeanProperties?.VersionManual }}></div>
                        </div>
                    </div>
                    <VisorAnyDocument url={bean.URL} type={bean.DocType} />
                </Modal>
            </div>
        </div>
    )
}